import Button from 'carbon-components-react/lib/components/Button';
import ArrowRight16 from '@carbon/icons-react/lib/arrow--right/16';
import { withPrefix } from "gatsby";
import * as React from 'react';
export default {
  Button,
  ArrowRight16,
  withPrefix,
  React
};